export default __webpack_public_path__ + "javascripts/components/promos/RepublishPanel/cc.logo-bd8e0798760af41b1850018ef2db81fb.svg";